import Header from "./Header";
import Footer from "./Footer";
import CookieConsent from "./CookieConsent";
import { useSettings } from "@/hooks/useSettings";

export default function Layout({ children }) {
  const { settings } = useSettings();
  // The header sticks with its own bg-white; the front-page hero opts out via
  // its own bg-white. Everywhere else — page bodies, list pages, article
  // gutters, the footer — inherits the editor-chosen background.
  const bgUrl = (settings.background_url || "").trim();
  const bgMode = settings.background_mode === "cover" ? "cover" : "tile";
  const style = bgUrl
    ? bgMode === "cover"
      ? {
          backgroundImage: `url(${bgUrl})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          backgroundAttachment: "fixed",
        }
      : {
          backgroundImage: `url(${bgUrl})`,
          backgroundRepeat: "repeat",
        }
    : undefined;
  return (
    <div className="App min-h-screen flex flex-col !bg-neutral-200" data-testid="site-layout">
      <Header />
      <div
        className="max-w-[1440px] mx-auto w-full flex-1 flex flex-col border-l border-r border-neutral-700"
        style={style}
        data-testid="site-body"
      >
        <main className="flex-1">{children}</main>
        <Footer />
      </div>
      <CookieConsent />
    </div>
  );
}
